import type { StyleRule } from '@archipro-design/aria';
import {
    pxToRem,
    pxArrayToRem,
    tileGridClassName,
    HeaderClassName,
    gridClassName,
    labelClassName,
    projectTileClassName,
    buttonClassName,
} from '@archipro-design/aria';

export const FeaturedProjectsWrapper: StyleRule = ({
    theme: { screen, siteVariables },
}) => {
    return {
        marginBottom: pxToRem(80),

        [`& .${tileGridClassName}`]: {
            paddingTop: pxToRem(5),

            [screen.tablet]: {
                paddingBottom: 0,
            },

            [`& .${HeaderClassName}`]: {
                marginBottom: pxToRem(23),
                padding: pxArrayToRem([0, 18, 0, 18]),
                fontSize: pxToRem(18),
                lineHeight: 1,
                letterSpacing: siteVariables.letterSpacingSmall,
                textAlign: 'left',
                fontWeight: '500',

                [screen.tablet]: {
                    padding: 0,
                    marginBottom: pxToRem(60),
                    whiteSpace: 'pre-line',
                    letterSpacing: siteVariables.letterSpacingSmall,
                    fontSize: pxToRem(22),
                    marginLeft: pxToRem(935),
                },
            },

            [`& .${gridClassName}`]: {
                gridRowGap: pxToRem(40),

                [screen.tablet]: {
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gridRowGap: pxToRem(112),
                },

                [`& .${projectTileClassName}`]: {
                    [screen.tablet]: {
                        padding: pxArrayToRem([14, 14, 0, 14]),
                    },
                },
            },

            [screen.tablet]: {
                marginBottom: 0,
            },
        },

        [screen.tablet]: {
            marginLeft: pxToRem(-14),
            marginRight: pxToRem(-14),
        },

        [screen.desktop]: {
            marginBottom: pxToRem(240),
        },
    };
};

export const LoadMoreButtonWrapper: StyleRule = ({ theme: { screen } }) => ({
    margin: `${pxToRem(35)} auto 0 auto`,

    [screen.tablet]: {
        margin: `${pxToRem(52)} 0 0 ${pxToRem(937)}`,
    },
});

export const LoadMoreButton: StyleRule = ({
    theme: { siteVariables, screen },
}) => ({
    [`&.${buttonClassName}`]: {
        padding: pxArrayToRem([24, 42]),
        border: `1px solid ${siteVariables.colors.charcoal['250']}`,
        textTransform: 'uppercase',

        [`& .${labelClassName}`]: {
            fontWeight: 500,
            letterSpacing: siteVariables.letterSpacingMedium,
        },

        [screen.max.tablet]: {
            background: 'transparent',
            width: '100%',
            margin: pxArrayToRem([0, 19]),
            padding: pxArrayToRem([15, 16]),
            border: 'none',
            outline: `${pxToRem(1)} solid ${
                siteVariables.colors.charcoal['250']
            }`,
            [`& .${labelClassName}`]: {
                fontSize: siteVariables.fontSizes['label02'],
                color: siteVariables.colors.charcoal['250'],
                fontWeight: 500,
            },
        },
    },
});
